var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.haveLoaders)?_c('div',{staticClass:"loader color--white grid-x position-fixed align-middle align-center"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","size":"3x","spin":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }